module.exports = __webpack_public_path__ + "static/pitbull-010c57ee2c335e5349f4e61a0ac079ee.svg";